import React, { useState, useEffect, createContext, useContext } from 'react';

const FeedbackContext = createContext();

export function FeedbackProvider({ children }) {
  const [toast, setToast] = useState(null);
  const [modal, setModal] = useState(null);

  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  };

  const showModal = (content) => setModal(content);
  const closeModal = () => setModal(null);

  return (
    <FeedbackContext.Provider value={{ showToast, showModal, closeModal }}>
      {children}
      
      {/* Toast Notification */}
      {toast && (
        <div className={`fixed bottom-8 right-8 z-[100] px-6 py-4 rounded-2xl shadow-2xl animate-slide-up flex items-center gap-4 border ${
          toast.type === 'success' ? 'bg-[#0a0c10] border-slate-700 text-white' : 'bg-red-50 border-red-100 text-red-800'
        }`}>
          <div className={`w-2 h-2 rounded-full ${toast.type === 'success' ? 'bg-green-500 shadow-[0_0_10px_rgba(34,197,94,0.5)]' : 'bg-red-500'}`} />
          <span className="text-[10px] font-black uppercase tracking-widest">{toast.message}</span>
        </div>
      )}

      {/* Modal Overlay */}
      {modal && (
        <div className="fixed inset-0 z-[150] flex items-center justify-center p-6 sm:p-12">
          <div 
            className="absolute inset-0 bg-[#0a0c10]/80 backdrop-blur-md animate-fade-in" 
            onClick={closeModal}
          />
          <div className="relative w-full max-w-2xl bg-white rounded-[2rem] shadow-[0_50px_100px_rgba(0,0,0,0.35)] overflow-hidden animate-slide-up max-h-[95vh] flex flex-col">
            {/* Header */}
            <div className="p-6 sm:p-8 pb-4 flex justify-between items-start bg-white sticky top-0 z-10">
              <div>
                <h2 className="text-xl font-black text-slate-800 uppercase tracking-tight leading-none">{modal.title}</h2>
                <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest mt-2">{modal.subtitle}</p>
              </div>
              <button 
                onClick={closeModal}
                className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center hover:bg-slate-100 transition-colors"
              >
                <span className="text-slate-400 text-lg leading-none">×</span>
              </button>
            </div>
            
            {/* Content Area */}
            <div className="flex-1 overflow-y-auto p-6 sm:p-8 pt-0 custom-scrollbar">
              <div className="space-y-4">
                {modal.content}
              </div>

              {(modal.confirmText || modal.cancelText || modal.showFooter) && (
              <div className="mt-10 flex gap-4">
                <button 
                  onClick={closeModal}
                  className="flex-1 py-4 rounded-2xl bg-slate-50 text-slate-400 text-[10px] font-black uppercase tracking-widest hover:bg-slate-100 transition-all"
                >
                  {modal.cancelText || 'Cancel'}
                </button>
                <button 
                  onClick={() => {
                    modal.onConfirm();
                    closeModal();
                  }}
                  className="flex-1 py-4 rounded-2xl bg-[#0a0c10] text-white text-[10px] font-black uppercase tracking-widest hover:translate-y-[-2px] transition-all shadow-xl"
                >
                  {modal.confirmText || 'Confirm'}
                </button>
              </div>
              )}
            </div>
          </div>
        </div>
      )}
    </FeedbackContext.Provider>
  );
}

export function useFeedback() {
  return useContext(FeedbackContext);
}
